/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { GetEmployeeResponse } from '../models/get-employee-response';
import { SMSRequest } from '../models/smsrequest';
import { JwtAuthentificationResponse } from '../models/jwt-authentification-response';
import { LoginRequest } from '../models/login-request';
import { RefreshTokenRequest } from '../models/refresh-token-request';
import { CreateEmployeeRequest } from '../models/create-employee-request';
import { UpdateEmployeeRequest } from '../models/update-employee-request';
@Injectable({
  providedIn: 'root',
})
class AuthService extends __BaseService {
  static readonly AuthSendSMSPath = '/Auth/SendSMS';
  static readonly AuthLoginPath = '/Auth/Login';
  static readonly AuthLoginAsUserPath = '/Auth/LoginAsUser';
  static readonly AuthRefreshTokenPath = '/Auth/RefreshToken';
  static readonly AuthCreatePath = '/Auth/Create';
  static readonly AuthGetUserFromAccessTokenPath = '/Auth/GetUserFromAccessToken';
  static readonly AuthGetAllPath = '/Auth/GetAll';
  static readonly AuthGetByIdPath = '/Auth/GetById';
  static readonly AuthGetAllByJobPath = '/Auth/GetAllByJob';
  static readonly AuthGetByEmailPath = '/Auth/GetByEmail';
  static readonly AuthUpdatePath = '/Auth/Update';
  static readonly AuthDeletePath = '/Auth/Delete';
  static readonly AuthIsUserConnectedToProjectPath = '/Auth/IsUserConnectedToProject';
  static readonly AuthGetForApprovalProcessByJobPath = '/Auth/GetForApprovalProcessByJob';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param request undefined
   */
  AuthSendSMSResponse(request: SMSRequest): __Observable<__StrictHttpResponse<GetEmployeeResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/Auth/SendSMS`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<GetEmployeeResponse>;
      })
    );
  }
  /**
   * @param request undefined
   */
  AuthSendSMS(request: SMSRequest): __Observable<GetEmployeeResponse> {
    return this.AuthSendSMSResponse(request).pipe(
      __map(_r => _r.body as GetEmployeeResponse)
    );
  }

  /**
   * @param request undefined
   */
  AuthLoginResponse(request: LoginRequest): __Observable<__StrictHttpResponse<JwtAuthentificationResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/Auth/Login`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<JwtAuthentificationResponse>;
      })
    );
  }
  /**
   * @param request undefined
   */
  AuthLogin(request: LoginRequest): __Observable<JwtAuthentificationResponse> {
    return this.AuthLoginResponse(request).pipe(
      __map(_r => _r.body as JwtAuthentificationResponse)
    );
  }

  /**
   * @param request undefined
   */
  AuthLoginAsUserResponse(request: LoginRequest): __Observable<__StrictHttpResponse<JwtAuthentificationResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/Auth/LoginAsUser`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<JwtAuthentificationResponse>;
      })
    );
  }
  /**
   * @param request undefined
   */
  AuthLoginAsUser(request: LoginRequest): __Observable<JwtAuthentificationResponse> {
    return this.AuthLoginAsUserResponse(request).pipe(
      __map(_r => _r.body as JwtAuthentificationResponse)
    );
  }

  /**
   * @param request undefined
   */
  AuthRefreshTokenResponse(request: RefreshTokenRequest): __Observable<__StrictHttpResponse<JwtAuthentificationResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/Auth/RefreshToken`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<JwtAuthentificationResponse>;
      })
    );
  }
  /**
   * @param request undefined
   */
  AuthRefreshToken(request: RefreshTokenRequest): __Observable<JwtAuthentificationResponse> {
    return this.AuthRefreshTokenResponse(request).pipe(
      __map(_r => _r.body as JwtAuthentificationResponse)
    );
  }

  /**
   * @param createUserRequest undefined
   */
  AuthCreateResponse(createUserRequest: CreateEmployeeRequest): __Observable<__StrictHttpResponse<GetEmployeeResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = createUserRequest;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/Auth/Create`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<GetEmployeeResponse>;
      })
    );
  }
  /**
   * @param createUserRequest undefined
   */
  AuthCreate(createUserRequest: CreateEmployeeRequest): __Observable<GetEmployeeResponse> {
    return this.AuthCreateResponse(createUserRequest).pipe(
      __map(_r => _r.body as GetEmployeeResponse)
    );
  }

  /**
   * @param accessToken undefined
   */
  AuthGetUserFromAccessTokenResponse(accessToken?: null | string): __Observable<__StrictHttpResponse<GetEmployeeResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (accessToken != null) __params = __params.set('accessToken', accessToken.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/Auth/GetUserFromAccessToken`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<GetEmployeeResponse>;
      })
    );
  }
  /**
   * @param accessToken undefined
   */
  AuthGetUserFromAccessToken(accessToken?: null | string): __Observable<GetEmployeeResponse> {
    return this.AuthGetUserFromAccessTokenResponse(accessToken).pipe(
      __map(_r => _r.body as GetEmployeeResponse)
    );
  }
  AuthGetAllResponse(): __Observable<__StrictHttpResponse<Array<GetEmployeeResponse>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/Auth/GetAll`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<GetEmployeeResponse>>;
      })
    );
  }  AuthGetAll(): __Observable<Array<GetEmployeeResponse>> {
    return this.AuthGetAllResponse().pipe(
      __map(_r => _r.body as Array<GetEmployeeResponse>)
    );
  }

  /**
   * @param Id undefined
   */
  AuthGetByIdResponse(Id?: null | string): __Observable<__StrictHttpResponse<GetEmployeeResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (Id != null) __params = __params.set('Id', Id.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/Auth/GetById`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<GetEmployeeResponse>;
      })
    );
  }
  /**
   * @param Id undefined
   */
  AuthGetById(Id?: null | string): __Observable<GetEmployeeResponse> {
    return this.AuthGetByIdResponse(Id).pipe(
      __map(_r => _r.body as GetEmployeeResponse)
    );
  }

  /**
   * @param job undefined
   */
  AuthGetAllByJobResponse(job?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9): __Observable<__StrictHttpResponse<Array<GetEmployeeResponse>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (job != null) __params = __params.set('job', job.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/Auth/GetAllByJob`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<GetEmployeeResponse>>;
      })
    );
  }
  /**
   * @param job undefined
   */
  AuthGetAllByJob(job?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9): __Observable<Array<GetEmployeeResponse>> {
    return this.AuthGetAllByJobResponse(job).pipe(
      __map(_r => _r.body as Array<GetEmployeeResponse>)
    );
  }

  /**
   * @param email undefined
   */
  AuthGetByEmailResponse(email?: null | string): __Observable<__StrictHttpResponse<GetEmployeeResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (email != null) __params = __params.set('email', email.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/Auth/GetByEmail`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<GetEmployeeResponse>;
      })
    );
  }
  /**
   * @param email undefined
   */
  AuthGetByEmail(email?: null | string): __Observable<GetEmployeeResponse> {
    return this.AuthGetByEmailResponse(email).pipe(
      __map(_r => _r.body as GetEmployeeResponse)
    );
  }

  /**
   * @param user undefined
   */
  AuthUpdateResponse(user: UpdateEmployeeRequest): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = user;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/Auth/Update`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }
  /**
   * @param user undefined
   */
  AuthUpdate(user: UpdateEmployeeRequest): __Observable<string> {
    return this.AuthUpdateResponse(user).pipe(
      __map(_r => _r.body as string)
    );
  }

  /**
   * @param params The `AuthService.AuthDeleteParams` containing the following parameters:
   *
   * - `userToReplaceId`:
   *
   * - `userId`:
   */
  AuthDeleteResponse(params: AuthService.AuthDeleteParams): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.userToReplaceId != null) __params = __params.set('userToReplaceId', params.userToReplaceId.toString());
    if (params.userId != null) __params = __params.set('userId', params.userId.toString());
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/Auth/Delete`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({ body: (_r as HttpResponse<any>).body === 'true' }) as __StrictHttpResponse<boolean>
      })
    );
  }
  /**
   * @param params The `AuthService.AuthDeleteParams` containing the following parameters:
   *
   * - `userToReplaceId`:
   *
   * - `userId`:
   */
  AuthDelete(params: AuthService.AuthDeleteParams): __Observable<boolean> {
    return this.AuthDeleteResponse(params).pipe(
      __map(_r => _r.body as boolean)
    );
  }

  /**
   * @param userId undefined
   */
  AuthIsUserConnectedToProjectResponse(userId?: null | string): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (userId != null) __params = __params.set('userId', userId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/Auth/IsUserConnectedToProject`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }
  /**
   * @param userId undefined
   */
  AuthIsUserConnectedToProject(userId?: null | string): __Observable<string> {
    return this.AuthIsUserConnectedToProjectResponse(userId).pipe(
      __map(_r => _r.body as string)
    );
  }

  /**
   * @param jobType undefined
   */
  AuthGetForApprovalProcessByJobResponse(jobType?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9): __Observable<__StrictHttpResponse<GetEmployeeResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (jobType != null) __params = __params.set('jobType', jobType.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/Auth/GetForApprovalProcessByJob`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<GetEmployeeResponse>;
      })
    );
  }
  /**
   * @param jobType undefined
   */
  AuthGetForApprovalProcessByJob(jobType?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9): __Observable<GetEmployeeResponse> {
    return this.AuthGetForApprovalProcessByJobResponse(jobType).pipe(
      __map(_r => _r.body as GetEmployeeResponse)
    );
  }
}

module AuthService {

  /**
   * Parameters for AuthDelete
   */
  export interface AuthDeleteParams {
    userToReplaceId?: null | string;
    userId?: null | string;
  }
}

export { AuthService }
